import getDomainInfo from "../api/getDomainInfo";
import Contact from "../components/Form/Contact";
import Wrapper from "../components/Layout/Wrapper/wrapper";
import { CleanLayout } from "../components/Layout/layout";
import CookiePolicy from "../components/atoms/CookiePolicy/cookiePolicy";
import Footer from "../components/molecules/Footer";
import FooterHome from "../components/molecules/Footer/FooterHome";
import Navbar from "../components/molecules/Navbar";
import Section from "../components/molecules/Section";
import { amplitudeTrackEvent } from "../components/utils/Amplitude/index";
import { sendViewItemListEvent } from "../components/utils/Datalayer/events";
import Gtm from "../components/utils/Gtm";
import ScrollToTop from "../components/utils/ScrollToTop";
import { Seo } from "../components/utils/Seo";
import { useSiteMetadata } from "../hooks/useSiteMetaData";
import components from "./components";
import themes from "./themes";
import { useEffect, useState } from "react";

const LandingHome = () => {
  const { data: domainData } = getDomainInfo();
  const [formAmount, setFormAmount] = useState(null);

  const theme = process.env.GATSBY_LANDING;
  const data = themes[theme];

  useEffect(() => {
    if (domainData) {
      setFormAmount(domainData.data.formAmount);
    }
  }, [domainData]);

  useEffect(() => {
    if (theme.includes("modal") && formAmount) {
      sendViewItemListEvent(["DS-64", "DS-11", "DS-82"], formAmount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formAmount]);

  useEffect(() => {
    if (theme.includes("modal")) {
      amplitudeTrackEvent("view_landing_home", {
        content: "landing-modal",
      });
    } else {
      amplitudeTrackEvent("view_landing_home", {
        content: "landing-fake",
      });
    }
  }, [theme]);

  return (
    <CleanLayout theme={theme}>
      <CookiePolicy />
      <Navbar
        domainData={domainData}
        data={data}
      />
      {data.template === "blog" && <ScrollToTop />}
      {data.sections.map((section) => {
        let RenderComponent = section.component && components[section.component.name];
        return (
          <Section
            key={section.id}
            id={section.id}
            hero={section.hero}
            background={section.backgroundImages}
            overlay={section.overlay}
            imageOverlay={section.imageOverlay}
            imageGradient={section.imageGradient}
            titleTag={section.titleTag}
            heroTitle={section.heroTitle}
            title={section.title}
            subtitle={section.subtitle}
            twoCols={section.twoCols}
            centered={section.centered}
            content={section.content}
            secondContent={section.secondContent}
            backgroundColor={section.backgroundColor}
            component={
              section.component && (
                <RenderComponent
                  domainData={domainData}
                  theme={theme}
                  {...section.component.props}
                />
              )
            }
          />
        );
      })}
      {data.contactForm && (
        <Wrapper>
          <Contact
            twoCols={true}
            fake={true}
            json={data.contactForm}
          />
        </Wrapper>
      )}
      {data.footer.showHomeFooter ? (
        <FooterHome data={data.footer} />
      ) : (
        <Footer
          domainData={domainData}
          template={data.template}
          data={data.footer}
        />
      )}
    </CleanLayout>
  );
};

export default LandingHome;

export const Head = () => {
  const { title } = useSiteMetadata();

  return (
    <Seo title={title}>
      <Gtm />
    </Seo>
  );
};
